import { PURCHASER_API_BASE_URL, getHeaders } from "../Constants";

// keep up to date with prisma schema when adding more entity types in purchaser-api
export type LabelEntityType = "RFQ" | "PRODUCT_CATALOG";

export type Label = {
    id: number;
    name: string;
    color: string;
    createdAt: string;
    entityType: LabelEntityType;
    usage?: string[]; // array of entity unique ids
    lastApplied?: Date | null;
    groupId?: number | null;
};

export type LabelGroup = {
    id: number;
    name: string;
    color: string;
    createdAt: string;
    entityType: LabelEntityType;
};

export default {
    getLabels: async (
        entityType?: LabelEntityType,
    ): Promise<{
        labels: Label[];
    }> => {
        let url = PURCHASER_API_BASE_URL + "/labels";
        if (entityType) url += `/${entityType}`;

        const res = await fetch(url, { headers: getHeaders() });
        const json = await res.json();
        // console.log(JSON.stringify(json, null, 2));
        return json;
    },
    createLabel: async (params: { name: string; color: string; entityType: LabelEntityType; groupId?: number | null }): Promise<Label> => {
        const url = PURCHASER_API_BASE_URL + `/labels`;
        const res = await fetch(url, { method: "POST", headers: getHeaders(), body: JSON.stringify(params) });
        const json = await res.json();
        // console.log(JSON.stringify(json, null, 2));
        return json;
    },
    updateLabel: async (params: { labelId: number; name?: string; color?: string; groupId?: number | null }) => {
        const url = PURCHASER_API_BASE_URL + `/labels/${params.labelId}`;
        const res = await fetch(url, { method: "PATCH", headers: getHeaders(), body: JSON.stringify(params) });
        const json = await res.json();
        // console.log(JSON.stringify(json, null, 2));
        return json;
    },
    deleteLabel: async (params: { labelId: number }) => {
        const url = PURCHASER_API_BASE_URL + `/labels/${params.labelId}`;
        const res = await fetch(url, { method: "DELETE", headers: getHeaders(), body: JSON.stringify(params) });
        const json = await res.json();
        // console.log(JSON.stringify(json, null, 2));
        return json;
    },

    getLabelGroups: async (
        entityType?: LabelEntityType,
    ): Promise<{
        groups: LabelGroup[];
    }> => {
        let url = PURCHASER_API_BASE_URL + "/labels/groups";
        if (entityType) url += `/${entityType}`;

        const res = await fetch(url, { headers: getHeaders() });
        const json = await res.json();
        // console.log(JSON.stringify(json, null, 2));
        return json;
    },
    createLabelGroup: async (params: { name: string; color: string; entityType: LabelEntityType }) => {
        const url = PURCHASER_API_BASE_URL + `/labels/groups`;
        const res = await fetch(url, { method: "POST", headers: getHeaders(), body: JSON.stringify(params) });
        const json = await res.json();
        // console.log(JSON.stringify(json, null, 2));
        return json;
    },
    updateLabelGroup: async (params: { groupId: number; name?: string; color?: string }) => {
        const url = PURCHASER_API_BASE_URL + `/labels/groups/${params.groupId}`;
        const res = await fetch(url, { method: "PATCH", headers: getHeaders(), body: JSON.stringify(params) });
        const json = await res.json();
        // console.log(JSON.stringify(json, null, 2));
        return json;
    },
    deleteLabelGroup: async (params: { groupId: number }) => {
        const url = PURCHASER_API_BASE_URL + `/labels/groups/${params.groupId}`;
        const res = await fetch(url, { method: "DELETE", headers: getHeaders(), body: JSON.stringify(params) });
        const json = await res.json();
        // console.log(JSON.stringify(json, null, 2));
        return json;
    },

    getRFQLabels: async (uniquePublicId: string) => {
        const url = PURCHASER_API_BASE_URL + `/v2/rfqs/${uniquePublicId}/labels`;
        const res = await fetch(url, { headers: getHeaders() });
        const json = await res.json();
        // console.log(JSON.stringify(json, null, 2));
        return json;
    },
    addLabelToRFQ: async (params: { uniquePublicId: string; labelId: number }) => {
        const url = PURCHASER_API_BASE_URL + `/v2/rfqs/${params.uniquePublicId}/labels`;
        const res = await fetch(url, { method: "POST", headers: getHeaders(), body: JSON.stringify({ labelId: params.labelId }) });
        const json = await res.json();
        // console.log(JSON.stringify(json, null, 2));
        return json;
    },
    deleteLabelFromRFQ: async (params: { uniquePublicId: string; labelId: number }) => {
        const url = PURCHASER_API_BASE_URL + `/v2/rfqs/${params.uniquePublicId}/labels`;
        const res = await fetch(url, { method: "DELETE", headers: getHeaders(), body: JSON.stringify({ labelId: params.labelId }) });
        const json = await res.json();
        // console.log(JSON.stringify(json, null, 2));
        return json;
    },
};
